/**
 * realtimeSlice.js
 * 
 * This file contains Redux slice for managing realtime data in the frontend application.
 * 
 * The slice defines the initial state, reducers, and actions for managing realtime data.
 */
import { createSlice } from "@reduxjs/toolkit";

export const realtimeSlice = createSlice({
  name: "realtime",
  initialState: {
    value: {

    
      dates: [new Date().setHours(0, 0, 0, 0), new Date().getTime()],
      limitDates: [new Date().setHours(0, 0, 0, 0), new Date().getTime()],
      currentDate: true,
      displayDate: new Date().getTime(),
      vizParam: "operator",
      locname:  "תל אביב -יפו",
      // locname: "חיפה" ,
      progress: 0,
      displayTime: "realtime",
      sliderVal: [0, 23],
      speedSliderVal: [0, 130],
      currentSec: 0,
      currentRequestSt: null,
      currentOperators: [],
      currentCluster: null,
      currentLines: null,
      currentStop: null,
      currentLineStartTime: null,
      locale: "Israel",
      timeInterval: {"Israel":15, "New York City":60},
      trafficLightsSliderVal: 80,
      showTrafficLights: false,
      showVehicles: true,
      // Opacity of the `network-mvt` road network layer, 0 - 1
      networkOpacity: 1,
      delayChartParam: "space",
      delayChartAxis: "start",

      operatorNames: {
        0: "",
        'undefined':"",
        2: 'רכבת ישראל',
        3: 'אגד',
        4: 'אלקטרה אפיקים תחבורה',
        5: 'דן',
        6: 'ש.א.מ',
        7: 'נסיעות ותיירות',
        8: 'גי.בי.טורס',
        10: 'מועצה אזורית אילות',
        14: 'נתיב אקספרס',
        15: 'מטרופולין',
        16: 'סופרבוס',
        18: 'קווים',
        20: 'כרמלית',
        21: 'כפיר',
        22: 'תבל',
        23: 'גלים',
        24: 'מועצה אזורית גולן',
        25: 'אלקטרה אפיקים',
        31: 'דן בדרום',
        32: 'דן באר שבע',
        33: 'כבל אקספרס',
        34: 'תנופה',
        35: 'בית שמש אקספרס',
        37: 'אקסטרה',
        38: 'אקסטרה ירושלים',
        39: 'דן נתיבים',
        40: 'יונייטד טורס',
        42: 'ירושלים-רמאללה איחוד',
        44: 'ירושלים-אבו-תור-ענאתא איחוד',
        45: 'ירושלים-אלווסט איחוד',
        47: 'ירושלים-הר הזיתים',
        49: 'ירושלים - עיסאוויה מחנה שעפאט איחוד',
        50: 'ירושלים-דרום איחוד',
        51: 'ירושלים-צור באהר איחוד',
        91: 'מוניות מטרו קו',
        93: 'מוניות מאיה יצחק שדה',
        97: 'אודליה מוניות בעמ',
        98: 'מוניות רב קווית 4-5',
        135: 'דרך אגד עוטף ירושלים',
        "MTABC": "MTABC",
        "MTA NYCT": "MTA NYCT",
      },

      operatorColors: {
        0: '#ffffff',
        'undefined': '#ffffff',
        2: '#00458a',
        3: '#00a85d',
        4: '#99d533',
        5: '#004b9a',
        6: '#006e35',
        7: '#ce021e',
        8: '#851a17',
        10: '#ee9f1c',
        14: '#f28c00',
        15: '#f5820b',
        16: '#064283',
        18: '#9acb39',
        20: '#fedc3d',
        21: '#007a8f',
        22: '#00a7e1',
        23: '#00adef',
        24: '#ff840d',
        25: '#0181c4',
        31: '#154982',
        32: '#154982',
        33: '#1677bc',
        34: '#007bac',
        35: '#f28c00',
        37: '#f4821f',
        38: '#00a0e2',
        39: '#3ce1b1',
        40: '#e02937',
        42: '#019a56',
        44: '#4054b2',
        45: '#4054b2',
        47: '#045896',
        49: '#2f9250',
        50: '#4054b2',
        51: '#465362',
        91: '#00ade2',
        93: '#004866',
        97: '#004866',
        98: '#004866',
        135: '#00a77b',
        "MTABC": '#e02937',
        "MTA NYCT": '#004866',
      },
       routeNamesKeyRef:{
        route_long_name:0,
        route_short_name:1,
        operatorref:2,
        directionref:3,
        
      },
      stopDetailsKeyRef:{
        stop_code:0,
        stop_name:1,
        lon:2,
        lat:3,
        route_ids:4,
      },
     tripsKeysRef:{
        recordedattime:0,
        datedvehiclejourneyref: 1,
        lineref: 2,
        longitude: 3,
        latitude: 4,
        bearing: 5,
        velocity: 6,
        route_short_name: 7,
        operatorref:8,
      
        interpolateLon: 9,
        interpolateLat: 10,
        interpolateVelocity: 11,
        interpolateBearing: 12,
        move: 13,
        currentVelocity: 14,
        currentBearing: 15,
        stage: 16,
        color: 17,
        valid: 18,
        position: 19
      },
    },
  },
  reducers: {
    change: (state) => {
      state.value = { ...state.value };
    },
    setVolCol: (state, action) => {
      state.value.volumeCol = action.payload;
    },
    setLocname: (state, action) => {
      state.value.locname = action.payload;
    },

    setDates: (state, action) => {
      state.value.dates = action.payload;
    },
    setLimitDates: (state, action) => {
      state.value.limitDates = action.payload;
    },
    setCurrentDate: (state, action) => {
      state.value.currentDate = action.payload;
    },
    setDisplayDate: (state, action) => {
      state.value.displayDate = action.payload;
    },
    setVizParam: (state, action) => {
      state.value.vizParam = action.payload;
    },
    setProgress: (state, action) => {
      state.value.progress = action.payload;
    },
    setDisplayTime: (state, action) => {
      state.value.displayTime = action.payload;
    },
    setSliderVal: (state, action) => {
      state.value.sliderVal = action.payload;
    },
    setSpeedSliderVal: (state, action) => {
      state.value.speedSliderVal = action.payload;
    },
    setCurrentSec: (state, action) => {
      state.value.currentSec = action.payload;
    },
    setCurrentRequestSt: (state, action) => {
      state.value.currentRequestSt = action.payload;
    },
    setCurrentOperators: (state, action) => {
      state.value.currentOperators = action.payload;
    },

    setCurrentCluster: (state, action) => {
      state.value.currentCluster = action.payload;
    },
    setCurrentLines: (state, action) => {
      state.value.currentLines = action.payload;
    },
     setCurrentStop: (state, action) => {
      state.value.currentStop = action.payload;
    },
    setCurrentLineStartTime: (state, action) => {
      state.value.currentLineStartTime = action.payload;
    },
    setLocale: (state, action) => {
      state.value.locale = action.payload;
    },
    setTimeInterval: (state, action) => {
      state.value.timeInterval = action.payload;
    },
    setTrafficLightsSliderVal: (state, action) => {
      state.value.trafficLightsSliderVal = action.payload;
    },
    setShowTrafficLights: (state, action) => {
      state.value.showTrafficLights = action.payload;
    },
    setShowVehicles: (state, action) => {
      state.value.showVehicles = action.payload;
    },
    setNetworkOpacity: (state, action) => {
      state.value.networkOpacity = action.payload;
    },
    setDelayChartParam: (state, action) => {
      state.value.delayChartParam = action.payload;
    },
  },
});

export const {
  change,
  setVolCol,
  setDates,
  setCurrentDate,
  setLimitDates,
  setDisplayDate,
  setVizParam,
  setLocname,
  setProgress,
  setDisplayTime,
  setSliderVal,
  setSpeedSliderVal,
  setCurrentSec,
  setCurrentRequestSt,
  setCurrentOperators,
  setCurrentCluster,
  setCurrentLines,
  setCurrentStop,
  setLocale,
  setCurrentLineStartTime,
  setTimeInterval,
  setTrafficLightsSliderVal,
  setShowTrafficLights,
  setShowVehicles,
  setNetworkOpacity,
} = realtimeSlice.actions;

export default realtimeSlice.reducer;